
import { Component, ModelSync, Prop, Vue, Watch } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import {Firmware} from"@/api/dtos/Firmware.schema";
import EditFrame from "../EditFrame.vue";
import moment from "moment";
import api from "@/api";
import CancelButton from '../buttons/CancelButton.vue'
import AddButton from '../buttons/AddButton.vue'
import DangerDialog from '../dialogs/DangerDialog.vue'
import { getDeviceTypes } from "@/api/stations";

@Component({
  components: {
    ContainerFrame,
    EditFrame,
    CancelButton,
    AddButton
  },
})
export default class CreateFirmwareDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop({ required: true })
  firmware!: Firmware;


  hardwareTypes: string[] = ["BIKE_PARK_BOX_CONTROLLER"];

  save () :void {
    this.$emit('save',this.firmware)
  }

  onCancel () {
    this.$emit('cancel')
  }

  async mounted(){

  }

  moment = moment;
}
